import type { DxPageView } from "./_types";
import logEvent from "./logEvent";

/**
 *
 * @param props This object contains
 */

const dxPageView = ({ query }: DxPageView) => {
  logEvent({ event: "dx_page_view", query });
};

export default dxPageView;
